var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5060_9462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6.50077C19.5 7.10077 19.1 7.70077 18.6 8.20077C17.5 9.40077 16.2 10.5008 14.7 11.3008C13.5 12.0008 12.3 12.5008 10.9 12.6008C9.3 12.8008 7.90001 12.5008 6.40001 11.9008C4.60001 11.1008 3.10001 10.0008 1.80001 8.60077C1.30001 8.10077 0.700006 7.50077 0.200006 6.90077C-0.0999939 6.60077 -0.0999939 6.30077 0.200006 5.90077C1.60001 4.10077 3.30001 2.60077 5.20001 1.40077C6.40001 0.700767 7.70001 0.200767 9.00001 0.100767C10.5 -0.099233 12 0.200767 13.4 0.800767C15.2 1.60077 16.8 2.70077 18.1 4.10077C18.7 4.70077 19.2 5.30077 19.7 5.90077C19.9 6.00077 19.9 6.10077 20 6.20077C20 6.30077 20 6.40077 20 6.50077ZM1.50001 6.40077C1.90001 6.80077 2.30001 7.30077 2.70001 7.60077C3.90001 8.90077 5.30001 10.0008 7.00001 10.8008C7.80001 11.2008 8.70001 11.4008 9.60001 11.4008C11 11.5008 12.3 11.1008 13.6 10.4008C15 9.70077 16.2 8.70077 17.3 7.60077C17.7 7.20077 18.1 6.80077 18.5 6.30077C18.1 5.90077 17.8 5.50077 17.4 5.10077C16.1 3.90077 14.7 2.70077 13 2.00077C12.2 1.60077 11.3 1.40077 10.4 1.30077C9.00001 1.20077 7.70001 1.60077 6.40001 2.30077C5.20001 2.90077 4.10001 3.70077 3.10001 4.70077C2.50001 5.20077 2.00001 5.80077 1.50001 6.40077Z",
    fill: "#06C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6.40398C14 8.60398 12.2 10.404 10 10.404C7.8 10.404 6 8.60398 6 6.40398C6 4.20398 7.8 2.50398 9.9 2.50398C12.2 2.40398 14 4.20398 14 6.40398ZM10 9.00397C11.5 9.00397 12.6 7.80398 12.6 6.40398C12.6 4.90398 11.4 3.80398 10 3.80398C8.5 3.80398 7.4 5.00398 7.4 6.40398C7.4 7.80398 8.5 9.00397 10 9.00397Z",
    fill: "#06C9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5060_9462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 12.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeImg);
export default __webpack_public_path__ + "static/media/eyeImg.3fd5e54b78f32319f346d5737ee003b0.svg";
export { ForwardRef as ReactComponent };